import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
	background: #1a1c1e;
	padding: 4rem;
	text-align: center;

	transform: translateY(50px);
 	opacity: 0;	
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 0.8s;
	a:after{
		display: none;
	}
	a {
		text-decoration: underline;
	}
	@media(max-width: 900px) {
		font-size: 1.6rem;
	}
` 
const Spacer = styled.span`
	margin: 0 2rem;
`

const Footer = () => (
	<StyledFooter>
		site by <a href="https://lach.io" target="_blank">lach.io</a> <Spacer>-</Spacer> © {new Date().getFullYear()}
	</StyledFooter>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/compontents/footer.js